module.exports = "mutation ($data: PageCreate!) {\n  PageCreate(data: $data) {\n    id\n  }\n}\n"